// globals.ts
import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { HttpHeaders } from '@angular/common/http';


@Injectable()
export class Globals {

  public baseUrlSimple: string = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/`;
  public baseUrl: string = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/beapi/`;
  public baseUrlEvents: string = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;

  public apiKey = '016b9bfb-c332-4994-b13c-ab1b16119ef1';
  public lang = 'en';
  public multiLang = true;
  public loading = false;

  public operatorId = 253;
  public serviceId = 125452;

  public roleId = 81;

  private httpOptions: any;

  public cacheFlyUrl = 'https://webportals.cachefly.net/middle-east/oma/omantel/me-om-omantel-gigaplay/assets/gifs/';


  public readonly eventRegist = {
    timweBi: true,
    analyticsId: null
  }
  
  // functions

  getLang() {
    // function to get lang if needed multi lang
    if (this.multiLang === true) {
      return localStorage.getItem('lang');
    } else {
      return this.lang;
    }
  }

  generateTXID() {
    return UUID.UUID();
  }

  generateDeviceId() {
    if (window.localStorage.getItem('deviceId')) {
      return window.localStorage.getItem('deviceId');
    } else {
      const deviceId = this.generateTXID();
      window.localStorage.setItem('deviceId', deviceId);
      return deviceId;
    }
  }

  generateSessionId() {
    if (window.sessionStorage.getItem('sessionId')) {
      return window.sessionStorage.getItem('sessionId');
    } else {
      const sessionId = this.generateTXID();
      window.sessionStorage.setItem('sessionId', sessionId);
      return sessionId;
    }
  }

  getHeaders(token = false) {
    this.httpOptions = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('apikey', this.apiKey)
      .set('lang', this.getLang())
      .set('txid', this.generateTXID())
      .set('device-id', this.generateDeviceId());

    if (token === true) {
      localStorage.getItem('token') && (this.httpOptions = this.httpOptions.set('token', localStorage.getItem('token')));      
    } else if (this.httpOptions.has('token')) {
      this.httpOptions = this.httpOptions.delete('token');
    }
    return this.httpOptions;
  }
}
